import React from 'react';
import Loading from 'components/_common/Loading';
import { getMenus } from 'models/admin';

const AdminUpdateV = ({
    t,
    params,
    setParams,
    handleChange,
    onHandleRoleChange,
    onHandlePhone,
    onHandleMenuChange, // 신규 추가
    isUpdate,
    submit,
    remove
}) => (
    <>
        {params.isLoaded && params.error == null ? (
            <>
                <div className="content-header">
                    <h1>
                        <font>관리자 관리</font>
                    </h1>
                </div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{isUpdate ? '관리자 수정' : '관리자 등록'}</h3>
                        </div>
                        <div className="g_update p-0 mt_30">
                            <table className="g_table table_type1">
                                <colgroup>
                                    <col width="20%" />
                                    <col width="80%" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>
                                            <label>계정ID</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => handleChange(e, 'admin.username', setParams, params)}
                                                    value={params.admin.username}
                                                    readOnly={isUpdate}
                                                    placeholder="계정ID를 입력해 주세요."
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>이름</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => handleChange(e, 'admin.name', setParams, params)}
                                                    value={params.admin.name}
                                                    placeholder="이름을 입력해 주세요."
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>비밀번호</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="password"
                                                    onChange={(e) => handleChange(e, 'admin.password', setParams, params)}
                                                    value={params.admin.password}
                                                    placeholder={isUpdate ? '변경할 비밀번호를 입력해 주세요.' : '비밀번호를 입력해 주세요.'}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    {/* <tr>
                                        <th>
                                            <label>이메일</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => handleChange(e, 'admin.email', setParams, params)}
                                                    value={params.admin.email}
                                                    placeholder="이메일을 입력해 주세요."
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>전화번호</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => onHandlePhone(e.target.value)}
                                                    value={params.admin.phone}
                                                    placeholder="전화번호를 입력해 주세요."
                                                />
                                            </div>
                                        </td>
                                    </tr> */}

                                    <tr>
                                        <th>
                                            <label>권한</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                {params.roles.map((role) => (
                                                    <div className="form-check checkbox-lg form-check-inline" key={role.key}>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            onChange={(e) => onHandleRoleChange(e, role.key)}
                                                            checked={role._checked}
                                                            name={'role_' + role.key}
                                                            id={'role_' + role.key}
                                                            value={role.key}
                                                            disabled={params.admin.roles?.includes('master')}
                                                        />
                                                        <label className="form-check-label" htmlFor={'role_' + role.key}>
                                                            {role.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>

                                    {/*  
                                        <tr>
                                            <th>
                                                <label>메뉴 권한</label>
                                            </th>
                                            <td>
                                                <div className="inner">
                                                    {params.admin.roles?.includes('master') ? (
                                                        <div className="alert alert-info">
                                                            최고관리자는 모든 메뉴에 접근 가능합니다.
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="mb-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-secondary mr-2"
                                                                    onClick={() => onHandleMenuChange('all', true)}
                                                                >
                                                                    전체 선택
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() => onHandleMenuChange('all', false)}
                                                                >
                                                                    전체 해제
                                                                </button>
                                                            </div>

                                                            
                                                            <div className="mb-3">
                                                                <h5 className="font-weight-bold mb-2">
                                                                    <i className="fas fa-bars mr-2"></i>사이드바 메뉴
                                                                </h5>
                                                                <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #dee2e6', padding: '10px', borderRadius: '4px' }}>
                                                                    {getMenus().filter(menu => menu.location === 'sidebar').map((menu) => (
                                                                        <div className="form-check" key={menu.path}>
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                onChange={(e) => onHandleMenuChange(menu.path, e.target.checked)}
                                                                                checked={params.admin.menus?.includes(menu.path)}
                                                                                id={'menu_' + menu.id}
                                                                                value={menu.path}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={'menu_' + menu.id}>
                                                                                <i className={`${menu.icon} mr-2`}></i>
                                                                                <strong>{menu.label}</strong>
                                                                                {menu.description && (
                                                                                    <small className="text-muted ml-2">- {menu.description}</small>
                                                                                )}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            
                                                            <div>
                                                                <h5 className="font-weight-bold mb-2">
                                                                    <i className="fas fa-cog mr-2"></i>관리 메뉴 (상단바)
                                                                </h5>
                                                                <div style={{ border: '1px solid #dee2e6', padding: '10px', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                                                                    {getMenus().filter(menu => menu.location === 'navbar').map((menu) => (
                                                                        <div className="form-check" key={menu.path}>
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                onChange={(e) => onHandleMenuChange(menu.path, e.target.checked)}
                                                                                checked={params.admin.menus?.includes(menu.path)}
                                                                                id={'menu_' + menu.id}
                                                                                value={menu.path}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={'menu_' + menu.id}>
                                                                                <i className={`${menu.icon} mr-2`}></i>
                                                                                <strong>{menu.label}</strong>
                                                                                {menu.description && (
                                                                                    <small className="text-muted ml-2">- {menu.description}</small>
                                                                                )}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    */}

                                </tbody>
                            </table>
                        </div>

                        <div className="card-footer">
                            <button
                                className="btn btn-success float-left"
                                onClick={() => {
                                    history.back();
                                }}
                            >
                                <i className="fas fa-long-arrow-left mr_10"></i>이전
                            </button>

                            <button type="button" onClick={submit} className="btn btn-primary float-right">
                                {isUpdate ? '수정' : '등록'}
                            </button>
                            {isUpdate && (
                                <button type="button" onClick={remove} className="btn btn-danger float-right mr_10">
                                    삭제
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <Loading />
        )}
    </>
);

export default AdminUpdateV;